import { useCallback } from 'react';

import { useLocation } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import useToggledState from '@zenbusiness/application-commons-hooks/useToggledState';

export default function useShouldLoginDialog() {
  const { login } = useAuthentication();
  const { pathname, search } = useLocation();
  const {
    state: isShouldLoginDialogOpen,
    on: openShouldLoginDialog,
    off: closeShouldLoginDialog
  } = useToggledState();

  const handleLogin = useCallback(() => {
    closeShouldLoginDialog();
    login(`${pathname}${search}`);
  }, [closeShouldLoginDialog, login, pathname, search]);

  return {
    isShouldLoginDialogOpen,
    openShouldLoginDialog,
    closeShouldLoginDialog,
    handleLogin
  };
}
